/**
 * THREE.js BVH Extensions
 *
 * This file patches THREE.js prototypes for accelerated raycasting using
 * three-mesh-bvh. Import this file once at app startup (e.g., in App.tsx).
 *
 * @see https://github.com/gkjohnson/three-mesh-bvh
 * @registry Side-effect-only module patching THREE.Mesh/BufferGeometry prototypes with BVH-accelerated raycasting; import once, no exports to use directly.
 */
import * as THREE from 'three';
import {
  acceleratedRaycast,
  computeBoundsTree,
  disposeBoundsTree,
} from 'three-mesh-bvh';

// Patch THREE.Mesh prototype for accelerated raycasting
THREE.Mesh.prototype.raycast = acceleratedRaycast;

// Patch THREE.BufferGeometry prototype for BVH tree operations
THREE.BufferGeometry.prototype.computeBoundsTree = computeBoundsTree;
THREE.BufferGeometry.prototype.disposeBoundsTree = disposeBoundsTree;

export {};
